import React, { useState } from "react";
import { Card, Frame, Layout, Page, Tabs } from "@shopify/polaris";
import MyCompany from "./company/MyCompany";
import PrivacyPolicy from "./privacy/PrivacyPolicy";
import ShippingAndReturnPolicy from "./shipping_return/ShippingAndReturnPolicy";
import Generation from "./generation/Generation";
import UserGuide from "./UserGuide";
import Support from "./Support";
import { CsI18n } from "../shared/csI18n/csI18n";

const Legal = ({ lang }) => {
  const
    [selectedPageIndex, setSelectedPageIndex] = useState(0),
    [userGuide, setUserGuide] = useState([]);

  const getUserGuide = () => userGuide;

  const handleSwitchPage = (selectedIndex) => setSelectedPageIndex(selectedIndex);

  const shallowCompareEqual = (newObj, prevObj, untracked) => {
    for (let keyObj in newObj) {
      if (!untracked.includes(keyObj) && newObj.hasOwnProperty(keyObj) && prevObj.hasOwnProperty(keyObj)) {
        // Most of state values are object. Two different objects will never be equal.
        if (JSON.stringify(newObj[keyObj]) !== JSON.stringify(prevObj[keyObj])) {
          return false;
        }
      }
    }

    return true;
  };

  const getSavedState = (savedState, untracked) => {
    let tmp = Object.assign({}, savedState);
    untracked.map(item => delete tmp[item]);
    return tmp;
  }

  const getStateToBeSaved = (state, untracked) => {
    let savedState = Object.assign({}, state);
    untracked.map(item => delete savedState[item]);
    return savedState;
  }

  const pages = [
    {
      id: 'my-company',
      content: CsI18n.t('My Company'),
      accessibilityLabel: CsI18n.t('My Company'),
      panelID: 'my-company-content',
      contentComponent: MyCompany,
      props: {
        shallowCompareEqual: shallowCompareEqual,
        getSavedState: getSavedState,
        getStateToBeSaved: getStateToBeSaved,
      },
    },
    {
      id: 'privacy',
      content: CsI18n.t('Privacy'),
      accessibilityLabel: CsI18n.t('Privacy'),
      panelID: 'privacy-content',
      contentComponent: PrivacyPolicy,
      props: {
        shallowCompareEqual: shallowCompareEqual,
        getSavedState: getSavedState,
        getStateToBeSaved: getStateToBeSaved,
      },
    },
    {
      id: 'shipping-return',
      content: CsI18n.t('Shipping & Return'),
      accessibilityLabel: CsI18n.t('Shipping & Return'),
      panelID: 'shipping-return-content',
      contentComponent: ShippingAndReturnPolicy,
      props: {
        shallowCompareEqual: shallowCompareEqual,
        getSavedState: getSavedState,
        getStateToBeSaved: getStateToBeSaved,
      },
    },
    {
      id: 'generate',
      content: CsI18n.t('Generate'),
      accessibilityLabel: CsI18n.t('Generate'),
      panelID: 'generate-content',
      contentComponent: Generation,
      props: { lang },
    },
    {
      id: 'user_guide',
      content: CsI18n.t('title.user_guide'),
      accessibilityLabel: CsI18n.t('title.user_guide'),
      panelID: 'documentation-content',
      contentComponent: UserGuide,
      props: {
        lang,
        getUserGuide: getUserGuide,
        setUserGuide: setUserGuide
      },
    },
    {
      id: 'support',
      content: CsI18n.t('Support'),
      accessibilityLabel: CsI18n.t('Support'),
      panelID: 'support-content',
      contentComponent: Support,
      props: {},
    },
  ];

  const selectedPage = pages[selectedPageIndex],
    TabContent = selectedPage.contentComponent,
    tabProps = selectedPage.props;

  return (
    <Frame>
      <Page fullWidth>
        <Layout>
          <Layout.Section>
            <Card>
              <Tabs tabs={pages} selected={selectedPageIndex} onSelect={handleSwitchPage}>
                <Card.Section>
                  <TabContent {...tabProps} />
                </Card.Section>
              </Tabs>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    </Frame>
  );
}

export default Legal;